import axios from "axios";
import baseUrl from "../url";

export const createApiClient = (customBaseUrl) => {
  const client = axios.create({
    baseURL: customBaseUrl || process.env.REACT_APP_API_BASE_URL || baseUrl,
    headers: {
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  client.interceptors.request.use(
    async (config) => {
      const token = sessionStorage.getItem("userToken");

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        !error.config.url.includes("login")
      ) {
        // Clear session storage token and user
        sessionStorage.removeItem("userToken");
        sessionStorage.removeItem("user");
        window.location.href = "/";
      }

      return Promise.reject(error);
    }
  );

  return client;
};
